import { AssetActionsButtonLayoutWithProvider } from 'asset-actions-lib';
import { CONTENT_ACTION_IDS } from '../constants/actionIds';
import { useContentActions } from '../providers/ContentActionsProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const ContentHoverActions = ({
  crmObject,
  trackerProps
}) => {
  const {
    contentRowActions,
    onActionError,
    primaryActionId,
    secondaryActionId
  } = useContentActions();
  return /*#__PURE__*/_jsx(AssetActionsButtonLayoutWithProvider, {
    actions: contentRowActions,
    crmObject: crmObject,
    trackerProps: trackerProps,
    primaryActionId: primaryActionId || CONTENT_ACTION_IDS.CLONE,
    secondaryActionId: secondaryActionId || CONTENT_ACTION_IDS.DETAILS,
    layoutUse: "hover-actions",
    onActionError: onActionError
  });
};
export default ContentHoverActions;